import styles from './plateField.module.css'
import { FieldType, FieldValue, FormField } from "../../../../features/ui"
import { validatePlate } from '../../../../features/data-types'

type Props = {
    defaultValue?: string
    onChange?: (value?: FieldValue) => void
}

export const PlateField = (props: Props): FormField => {
    const { defaultValue, onChange } = props

    return {
        name: 'plate',
        type: FieldType.TEXT,
        label: 'Patente',
        defaultValue,
        narrow: true,
        className: styles.plate,
        validate: validatePlate,
        onChange
    }
}
